var map = {
	"./black/camerafor2.png": "7J7n",
	"./blue/camerafor2.png": "mhoo",
	"./white/camerafor2.png": "rLve"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "03HM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/camerafor2\.png$
// module id = 03HM
// module chunks = 24